import React, { useState } from "react";
import { Lock } from "lucide-react";

const SecuritySubPage = ({ 
  passwordData, 
  setPasswordData, 
  handleChangePassword, 
  changingPassword
}) => {
  const [showCurrentPasscode, setShowCurrentPasscode] = useState(false);
  const [showNewPasscode, setShowNewPasscode] = useState(false);

  return (
    <div className="max-w-2xl mx-auto bg-white dark:bg-[#0B0F19] border border-slate-200 dark:border-slate-900 rounded-3xl p-6 md:p-8 shadow-xl">
      <div className="border-b border-slate-200 dark:border-slate-800 pb-5 mb-6">
        <h2 className="text-xl font-black text-slate-800 dark:text-white flex items-center gap-2">
          <Lock className="w-5 h-5 text-rose-500 dark:text-rose-400" />
          Update Security Passcode
        </h2>
        <p className="text-slate-500 text-xs mt-1">Configure your login passcode credentials. Keep this information confidential.</p>
      </div>

      <form onSubmit={handleChangePassword} className="space-y-5">
        <div className="grid grid-cols-1 gap-5">
          <div className="space-y-2">
            <label className="block text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">Current Passcode</label>
            <div className="relative">
              <input 
                type={showCurrentPasscode ? "text" : "password"} 
                value={passwordData.currentPassword}
                onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value.replace(/\D/g, "")})}
                maxLength="6"
                className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl focus:border-rose-500 text-slate-800 dark:text-white font-mono tracking-[0.4em] outline-none transition-all placeholder-slate-400 dark:placeholder-slate-500 pr-12 text-sm placeholder:font-sans placeholder:tracking-normal"
                placeholder="Enter current passcode"
                required
              />
              <button
                type="button"
                onClick={() => setShowCurrentPasscode(!showCurrentPasscode)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-rose-500 dark:hover:text-rose-400 transition-colors"
                tabIndex="-1"
              >
                {showCurrentPasscode ? (
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 01-1.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">New Passcode</label>
            <div className="relative">
              <input 
                type={showNewPasscode ? "text" : "password"} 
                value={passwordData.newPassword}
                onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value.replace(/\D/g, "")})}
                maxLength="6"
                className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl focus:border-rose-500 text-slate-800 dark:text-white font-mono tracking-[0.4em] outline-none transition-all placeholder-slate-400 dark:placeholder-slate-500 pr-12 text-sm placeholder:font-sans placeholder:tracking-normal"
                placeholder="Enter new passcode"
                required
              />
              <button
                type="button"
                onClick={() => setShowNewPasscode(!showNewPasscode)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-rose-500 dark:hover:text-rose-400 transition-colors"
                tabIndex="-1"
              >
                {showNewPasscode ? (
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 01-1.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                )}
              </button>
            </div>
            <p className="text-[10px] text-slate-400 dark:text-slate-500 mt-1 font-medium">New passcode must be exactly 6 digits, containing only numbers.</p>
          </div>
        </div>

        <div className="pt-4 border-t border-slate-200 dark:border-slate-800 flex justify-end">
          <button 
            type="submit" 
            disabled={changingPassword}
            className="px-8 py-3.5 bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-400 hover:to-pink-500 text-white font-extrabold text-xs uppercase tracking-wider rounded-xl shadow-lg shadow-rose-500/10 transition-all duration-300 disabled:opacity-70"
          >
            {changingPassword ? "Updating Passcode..." : "Update Passcode"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SecuritySubPage;
